import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "lead" }
const _hoisted_9 = { class: "col-sm-3" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "col-sm-2" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "col-sm-1" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "error" }

import { computed, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { DiscreteScaleLevel } from '@Scales/Model'
    import type { CriterionScaleEditorViewModel } from "@Criteria/Hierarchies/Components/CriterionScaleEditor"

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CriterionScaleEditor',
  props: {
        viewModel: {
            type: Object as PropType<CriterionScaleEditorViewModel>,
            required: true
        }
    },
  emits: ["assign-custom-scale"],
  setup(__props, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)

    const criterionId = computed(() => vm.value.criterionId)
    const criterionName = computed(() => vm.value.criterionName)
    const criterionDescription = computed(() => vm.value.criterionDescription)
    const error = computed(() => vm.value.error)

    function clearValidationErrors()
    {
        vm.value.error = null
    }

    function addLevel()
    {
        clearValidationErrors()
        vm.value.levels.push({ Name: null, Value: null, Definition: null })
    }

    function deleteLevel(l: DiscreteScaleLevel)
    {
        clearValidationErrors()
        vm.value.levels.remove(l)
    }

    function emitAssignCustomScale()
    {
        clearValidationErrors()
        emit("assign-custom-scale", criterionId.value, vm.value.levels)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, "Criterion: " + _toDisplayString(criterionName.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "criterion-scale-editor-form",
                  onSubmit: _withModifiers(emitAssignCustomScale, ["prevent"])
                }, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(criterionDescription.value), 1 /* TEXT */),
                  _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-sm-3\"><label>Scale level <span class=\"text-danger\">*</span></label></div><div class=\"col-sm-2\"><label>Value <span class=\"text-danger\">*</span></label></div><div class=\"col-sm-6\"><label>Definition</label></div></div>", 1)),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.value.levels, (sl) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: sl,
                        class: "row",
                        style: {"margin-bottom":"5px"}
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((sl.Name) = $event),
                            type: "text",
                            required: "",
                            maxlength: "100",
                            class: "form-control",
                            placeholder: "Level"
                          }, null, 8 /* PROPS */, _hoisted_10), [
                            [
                              _vModelText,
                              sl.Name,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((sl.Value) = $event),
                            placeholder: "Number...",
                            class: "form-control",
                            required: "",
                            min: "0",
                            step: "any"
                          }, null, 8 /* PROPS */, _hoisted_12), [
                            [
                              _vModelText,
                              sl.Value,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((sl.Definition) = $event),
                            type: "text",
                            class: "form-control",
                            placeholder: "Definition for level"
                          }, null, 8 /* PROPS */, _hoisted_14), [
                            [
                              _vModelText,
                              sl.Definition,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (deleteLevel(sl)),
                            class: "pointer fa fa-times"
                          }, null, 8 /* PROPS */, _hoisted_16)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(error.value), 1 /* TEXT */),
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: addLevel
                    }, "Add scale level")
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _cache[1] || (_cache[1] = _createElementVNode("button", {
                  type: "submit",
                  form: "criterion-scale-editor-form",
                  class: "btn btn-primary"
                }, "Update", -1 /* CACHED */))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})